import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import ListSubheader from '@material-ui/core/ListSubheader';
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/Info';

import p1 from './images/urbanhipster/p1.jpg';
import p2 from './images/urbanhipster/p2.jpg';
import p3 from './images/urbanhipster/p3.jpg';
import p4 from './images/urbanhipster/p4.jpg';
import p5 from './images/urbanhipster/p5.jpg';
import p6 from './images/urbanhipster/p6.jpg';
import p7 from './images/urbanhipster/p7.jpg';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: 750,
    height: 450,
  },
  icon: {
    color: 'rgba(255, 255, 255, 0.54)',
  },
});


const tileData = [
    {
        img: p1,
        title: 'With Filter, night scene',
        author: 'Richard Rahl',
    },
    {
        img: p2,
        title: 'Hipster scooter',
        author: 'author',
    },
    {
        img: p3,
        title: 'Wide view of city',
        author: 'author',
    },
    {
        img: p4,
        title: 'Girl with skateboard',
        author: 'author',
    },
    {
        img: p5,
        title: 'Colorful china town with girl, san francisco',
        author: 'author',
    },
    {
        img: p6,
        title: 'san francisco uphill',
        author: 'author',
    },
    {
        img: p7,
        title: 'night time bridge, colorful lights',
        author: 'author',
    },
];

function ImageListForSegment(props) {
  const { classes } = props;

  return (
    <div className={classes.root}>
      <GridList cellHeight={180} className={classes.gridList}>
        <GridListTile key="Subheader" cols={2} style={{ height: 'auto' }}>
        </GridListTile>
        {tileData.map(tile => (
          <GridListTile key={tile.img}>
            <img src={tile.img} alt={tile.title} />
            <GridListTileBar
              title={tile.title}
              subtitle={<span>by: {tile.author}</span>}
              actionIcon={
                <IconButton className={classes.icon}>
                  <InfoIcon />
                </IconButton>
              }
            />
          </GridListTile>
        ))}
      </GridList>
    </div>
  );
}

ImageListForSegment.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ImageListForSegment);


// WEBPACK FOOTER //
// ./src/components/personalization/ImageListForSegment.js